/* Coathaus - scripts propios (vanilla, sin librerias) */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada --------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.mt-reveal:not([data-mt-observed])');
    if (!items.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) {
      el.setAttribute('data-mt-observed', '1');
      obs.observe(el);
    });
  }

  /* --- Acordeon FAQ -------------------------------------------------------- */
  function initAccordions() {
    document.querySelectorAll('.mt-accordion__btn').forEach(function (btn) {
      if (btn.dataset.mtBound) return;
      btn.dataset.mtBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-accordion');
        if (!item) return;
        var open = item.classList.contains('is-open');
        var group = item.closest('.mt-faq__list');
        if (group && !open) {
          group.querySelectorAll('.mt-accordion.is-open').forEach(function (other) {
            other.classList.remove('is-open');
            var b = other.querySelector('.mt-accordion__btn');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* --- Cifras animadas ----------------------------------------------------- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]:not([data-mt-counted])');
    if (!nums.length) return;

    function run(el) {
      el.setAttribute('data-mt-counted', '1');
      var target = parseFloat(el.getAttribute('data-mt-count'));
      if (isNaN(target)) return;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var prefix = el.getAttribute('data-mt-prefix') || '';
      if (reduce) { el.textContent = prefix + target + suffix; return; }
      var start = null;
      var dur = 1400;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = Math.round(target * eased);
        el.textContent = prefix + val + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    nums.forEach(function (el) { obs.observe(el); });
  }

  /* --- Galeria de producto -------------------------------------------------- */
  function initGallery() {
    document.querySelectorAll('[data-mt-gallery]').forEach(function (gallery) {
      if (gallery.dataset.mtBound) return;
      gallery.dataset.mtBound = '1';
      var main = gallery.querySelector('[data-mt-gallery-main]');
      if (!main) return;
      gallery.querySelectorAll('[data-mt-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          main.src = src;
          main.alt = alt;
          gallery.querySelectorAll('[data-mt-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    });
  }

  /* --- Selector de variantes ------------------------------------------------ */
  function initVariants() {
    document.querySelectorAll('[data-mt-variants]').forEach(function (root) {
      if (root.dataset.mtBound) return;
      root.dataset.mtBound = '1';

      var dataEl = root.querySelector('[data-mt-variant-data]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var idInput = root.querySelector('[data-mt-variant-id]');
      var priceEl = root.querySelector('[data-mt-price]');
      var compareEl = root.querySelector('[data-mt-compare]');
      var addBtn = root.querySelector('[data-mt-add]');
      var addLabel = addBtn ? (addBtn.getAttribute('data-label') || addBtn.textContent.trim()) : '';
      var soldLabel = addBtn ? (addBtn.getAttribute('data-sold-label') || 'Sold out') : 'Sold out';

      function currentSelection() {
        var picked = [];
        root.querySelectorAll('[data-mt-option]').forEach(function (group) {
          var active = group.querySelector('.mt-option__value.is-active');
          picked.push(active ? active.getAttribute('data-value') : null);
        });
        return picked;
      }

      function match(sel) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < sel.length; j++) {
            if (sel[j] !== null && v.options[j] !== sel[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function apply() {
        var v = match(currentSelection());
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = v.price;
        if (compareEl) {
          if (v.compare_at_price) {
            compareEl.innerHTML = v.compare_at_price;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addLabel : soldLabel;
        }
        if (history.replaceState && v.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }

      root.querySelectorAll('.mt-option__value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-mt-option]');
          if (!group) return;
          group.querySelectorAll('.mt-option__value').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          apply();
        });
      });
    });
  }

  /* --- Comparador antes / despues ------------------------------------------ */
  function initBeforeAfter() {
    document.querySelectorAll('[data-mt-ba]').forEach(function (frame) {
      if (frame.dataset.mtBound) return;
      frame.dataset.mtBound = '1';
      var range = frame.querySelector('[data-mt-ba-range]');
      if (!range) return;

      function apply() {
        frame.style.setProperty('--mt-ba-pos', range.value + '%');
      }

      range.addEventListener('input', apply);
      range.addEventListener('change', apply);
      apply();
    });
  }

  /* --- Arranque ------------------------------------------------------------- */
  function boot() {
    initReveal();
    initAccordions();
    initCounters();
    initGallery();
    initVariants();
    initBeforeAfter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de Shopify recarga secciones sin recargar la pagina
  document.addEventListener('shopify:section:load', boot);
})();
